
import {Component, Input} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {DatePickerModule} from 'primeng/datepicker';
import {TranslateService} from '@ngx-translate/core';
import {DEFAULT_DATE_FORMAT} from '@gnv-shared/constants';
import {PrimeNG} from 'primeng/config';
import {FloatLabel} from 'primeng/floatlabel';
import {AddAsteriskIfRequiredDirective} from '../../directives/form/add-asterisk-if-required.directive';

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, MatIconModule, DatePickerModule, FloatLabel, AddAsteriskIfRequiredDirective],
})
export class DateComponent {
  @Input() label!: string;
  @Input() dateFormControl!: FormControl<Date | null>;

  public dateFormat = DEFAULT_DATE_FORMAT;

  constructor(
    private config: PrimeNG,
    private translate: TranslateService
  ) {
    this.config.setTranslation(this.translate.instant('primeng'));
  }
}
